import type React from 'react'

export const ChartContainer: React.FC<React.PropsWithChildren> = ({
  children,
}) => <div className="relative h-fit flex flex-col">{children}</div>

export const SwitchContainer: React.FC<React.PropsWithChildren> = ({
  children,
}) => <div className="p-3 w-full flex justify-between">{children}</div>

export const DisplayModeSwitch: React.FC<React.PropsWithChildren> = ({
  children,
}) => <div className="max-w-[200px]">{children}</div>

export const TimeRangeSwitch: React.FC<React.PropsWithChildren> = ({
  children,
}) => <div>{children}</div>
